import { Button, Grid, IconButton, Stack } from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import FooterInstagramPosts from "./FooterInstagramPosts";

const TRAINER_APP_INSTAGRAM = "https://www.instagram.com/trainerxapp/";

const publicFooterPaths = [
  "/",
  "/about",
  "/about-us",
  "/how-it-works",
  "/pricing",
  "/privacy-policy",
];

const Footer = () => {
  const location = useLocation();
  if (publicFooterPaths.includes(location.pathname)) {
    return (
      <Grid
        item
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap={1.5}
        sx={{ py: { xs: 2.5, sm: 3 }, width: "100%" }}
      >
        <Stack
          direction="row"
          flexWrap="wrap"
          justifyContent="center"
          alignItems="center"
          spacing={1}
          useFlexGap
        >
          <Button size="small" variant="text" component={Link} to="/about-us">
            About Us
          </Button>
          <Button
            size="small"
            variant="text"
            component={Link}
            to="/privacy-policy"
          >
            Privacy Policy
          </Button>
          <IconButton
            size="small"
            component="a"
            href={TRAINER_APP_INSTAGRAM}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Trainer App on Instagram (@trainerxapp)"
            sx={{ color: "#E4405F" }}
          >
            <InstagramIcon fontSize="small" />
          </IconButton>
        </Stack>
        <FooterInstagramPosts />
      </Grid>
    );
  } else {
    return <></>;
  }
};

export default Footer;
